

import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, Divider, Grid, Dialog, DialogActions, DialogContent, DialogContentText, 
    DialogTitle, Slide, CircularProgress, } from '@material-ui/core';
import { } from '@material-ui/icons';
import fb from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';
import takeHWK from './takeHWK';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      margin: 'auto',
      width: '75%',
      margingBottom: 'auto'
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: 20,
        width: '75%',
        margin: 'auto'
      },
      container2: {
        display: 'block',
        flexWrap: 'wrap',
        width: '100%',
        padding: 10,
        margin: 'auto',
        alignItems: 'center',
        overflowX: 'auto'
        },
      button: {
        margin: theme.spacing.unit,
        width: 250,
        hieght: 100
      },
})

class ViewWrk extends Component{
    constructor(props){
        super(props)
        this.state = {
            tasks: [],
            prevTasks: [],
            tests: [],
            prevTests: [],
            overdueTasks: [],
            overdueTests: []
        }
    }

    componentDidMount ()  {
        var arr = []
        var testArr = []
        var arrCompleted = []
        var testArrCompleted = []
        var arrOverdue = []
        var testArrOverdue = [] 
        db.collection('AssignedTasks').get()
            .then(snapshot => {
                snapshot.forEach( hwk => {
                    hwk.data().AssignedTo.forEach(record => {
                    if (record.CompletionDate == 'N/A' && new Date(hwk.data().Deadline).getTime() > new Date().getTime() ) {
                            if (record.Student == sessionStorage.getItem('uid')) {
                                console.log('currently active', record, hwk.data().Subject)
                                if (hwk.data().Test == false) { 
                                //INSIDE THE TEST IF
                                    if (arr.length > 0) {
                                        arr.forEach(subject => { 
                                            const index = arr.indexOf(subject)
                                            if (subject.subject == hwk.data().Subject){ 
                                                subject.tasks.push({id: hwk.id, perQ: record.perQuestion})
                                            } else
                                            if (index == arr.length -1){
                                                arr.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})
                                            }
                                        })
                                    } else {arr.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})}
                                } else { 
                                    if (testArr.length > 0) {
                                        testArr.forEach(subject => { 
                                            const index = testArr.indexOf(subject)
                                            if (subject.subject == hwk.data().Subject){ 
                                                subject.tasks.push({id: hwk.id, perQ: record.perQuestion})
                                            } else
                                            if (index == testArr.length -1){
                                                testArr.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})
                                            }
                                        })
                                    } else {testArr.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})} 
                                }
                            }
                        
                    } else
                    if (record.CompletionDate == 'N/A' && new Date(hwk.data().Deadline).getTime() < new Date().getTime()){
                            if (record.Student == sessionStorage.getItem('uid')) {
                                console.log('over due', record, hwk.data().Subject)
                                if (hwk.data().Test == false) { 
                                //INSIDE THE TEST IF
                                if (arrOverdue.length > 0) {
                                    arrOverdue.forEach(subject => { 
                                            const index = arrOverdue.indexOf(subject)
                                            if (subject.subject == hwk.data().Subject){ 
                                                subject.tasks.push({id: hwk.id, perQ: record.perQuestion})
                                            } else
                                            if (index == arrOverdue.length -1){
                                                arrOverdue.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})
                                            }
                                        })
                                    } else {arrOverdue.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})} 
                                } else { 
                                    if (testArrOverdue.length > 0) {
                                        testArrOverdue.forEach(subject => { 
                                            const index = testArrOverdue.indexOf(subject)
                                            if (subject.subject == hwk.data().Subject){ 
                                                subject.tasks.push({id: hwk.id, perQ: record.perQuestion})
                                            } else
                                            if (index == testArrOverdue.length -1){
                                                testArrOverdue.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})
                                            }
                                        })
                                    } else {testArrOverdue.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})}
                                }
                            }
                    }
                    else {
                            if (record.Student == sessionStorage.getItem('uid')) {
                                console.log('previous', record, hwk.data().Subject)
                                if (hwk.data().Test == false) { 
                                //INSIDE THE TEST IF
                                if (arrCompleted.length > 0) {
                                    arrCompleted.forEach(subject => { 
                                            const index = arrCompleted.indexOf(subject)
                                            if (subject.subject == hwk.data().Subject){ 
                                                subject.tasks.push({id: hwk.id, perQ: record.perQuestion})
                                            } else
                                            if (index == arrCompleted.length -1){
                                                arrCompleted.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})
                                            }
                                        })
                                    } else {arrCompleted.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})}
                                } else { 
                                    if (testArrCompleted.length > 0) {
                                        testArrCompleted.forEach(subject => { 
                                            const index = testArrCompleted.indexOf(subject)
                                            if (subject.subject == hwk.data().Subject){ 
                                                subject.tasks.push({id: hwk.id, perQ: record.perQuestion})
                                            } else
                                            if (index == testArrCompleted.length -1){
                                                testArrCompleted.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})
                                            }
                                        })
                                    } else {testArrCompleted.push({subject: hwk.data().Subject, tasks: [{id: hwk.id, perQ: record.perQuestion}]})}
                                }
                            }
                        }
                    })
                    
                })
                if (snapshot) {
                    this.setState({
                        tasks: arr,
                        tests: testArr,
                        prevTasks: arrCompleted,
                        prevTests: testArrCompleted,
                        overdueTasks: arrOverdue,
                        overdueTests: testArrOverdue
                    })
                }
                
            console.log(this.state)
            })
            
            
            
            
           
    }

    handleClose = () => {
        this.setState({ 
            open: false,
            score: 0,
        });
    };

    handleClickOpen = (taskData) => {
        this.setState({ open: true });
        this.getFeedback(taskData)
    };

    doNothing = () => {}

    openTask = (name) => {
       var  urlName = name.replace(' ', '-')
        window.location.replace('/' + this.props.match.params.id + '/tests' + '/' + urlName)
    }


    getFeedback = (taskData) => {
        //WE GRAB THIS BECAUSE IN THE FUTURE THIS WILL BE RUN USING A CLOUD FUNCTION TO REDUCE
        //FRONT END LOAD BUT CLIENT WANTS END TO END ASAP SO WE GO HACKY
        var score = 0;
        var totalMarks = 0;
        const questions = taskData.perQ
        var correctArr = []
        var tryAgainArr = []
        
        
            questions.map(question => {
                totalMarks = totalMarks + parseInt(question.weight)
                if(question.result == true){
                   score = score + parseInt(question.weight)
                   correctArr.push(question)
                } else { 
                    tryAgainArr.push({
                        id: question.id,
                        tags: question.tags,
                        question: question.question,
                        weight: question.weight,
                        file: question.file
                    })
                }
            })
        
        if (score > 0) { 
            this.setState({
                score: Math.round((((score / totalMarks) * 100) * 100)/100),
                perQuestion: correctArr,
                wrongQuestions: tryAgainArr,
                testTitle: taskData.id
            }) 
        } else {
            console.log('score was less than 1', score)
            this.setState({
                score: '0',
                perQuestion: correctArr,
                wrongQuestions: tryAgainArr,
                testTitle: taskData.id
            }) 
        }
    }

    render(){
        const { classes } = this.props;
        return (
            <div> 
                <div>
                    {(this.state.tasks.length > 0 || this.state.tests.length > 0 || this.state.prevTasks.length > 0 || this.state.prevTests.length > 0 || this.state.overdueTasks.length > 0 || this.state.overdueTests.length > 0? 
                    <div>
                    <Paper className={classes.root} elevation={1}>
                        <Typography variant='headline'>
                            Your overdue Tests
                        </Typography>
                        <Divider/>
                        <br/>
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            {this.state.overdueTests.length > 0 ? 
                                this.state.overdueTests.map(subject => {
                                    return (
                                        <Grid item xs={8} l={4}>
                                            <Paper className={classes.container2} elevation={1}>
                                                <Typography variant='title'>
                                                    {subject.subject}
                                                </Typography>
                                                <Divider/>
                                                <Grid container
                                                    spacing={24}
                                                    direction='row'
                                                    justify='space-evenly'
                                                    alignContent='center'
                                                >
                                                    <br/>
                                                    {subject.tasks.map(task => {
                                                        return (
                                                            <Grid item xs={12}>
                                                                <Button className={classes.button} variant='outlined' onClick={() => this.openTask(task.id)}>
                                                                    <Typography variant='body2'>
                                                                        {task.id}
                                                                    </Typography>
                                                                </Button>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    )
                                })

                            :

                            <div>
                                <br/>
                                    <Typography variant='title'>
                                        You have no overdue tests
                                    </Typography>
                                <br/>
                            </div>
                            }
                        </Grid>
                    </Paper>
                    <br/>
                    <Paper className={classes.root} elevation={1}>
                        <Typography variant='headline'>
                            Your overdue Homework
                        </Typography>
                        <Divider/>
                        <br/>
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            {this.state.overdueTasks.length > 0 ? 
                                this.state.overdueTasks.map(subject => {
                                    return (
                                        <Grid item xs={8} l={4}>
                                            <Paper className={classes.container2} elevation={1}>
                                                <Typography variant='title'>
                                                    {subject.subject}
                                                </Typography>
                                                <Divider/>
                                                <Grid container
                                                    spacing={24}
                                                    direction='row'
                                                    justify='space-evenly'
                                                    alignContent='center'
                                                >
                                                    <br/>
                                                    {subject.tasks.map(task => {
                                                        return (
                                                            <Grid item xs={12}>
                                                                <Button className={classes.button} variant='outlined' onClick={() => this.openTask(task.id)}>
                                                                    <Typography variant='body2'>
                                                                        {task.id}
                                                                    </Typography>
                                                                </Button>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    )
                                })

                            :
                            
                            <div>
                                <br/>
                                    <Typography variant='title'>
                                        You have no overdue homework
                                    </Typography>
                                <br/>
                            </div>
                            }
                        </Grid>
                    </Paper>
                    <br/>
                    <Paper className={classes.root} elevation={1}>
                        <Typography variant='headline'>
                            Your currently outstanding Tests
                        </Typography>
                        <Divider/>
                        <br/>
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            {this.state.tests.length > 0 ? 
                                this.state.tests.map(subject => {
                                    return (
                                        <Grid item xs={8} l={4}>
                                            <Paper className={classes.container2} elevation={1}>
                                                <Typography variant='title'>
                                                    {subject.subject}
                                                </Typography>
                                                <Divider/>
                                                <Grid container
                                                    spacing={24}
                                                    direction='row'
                                                    justify='space-evenly'
                                                    alignContent='center'
                                                >
                                                    <br/>
                                                    {subject.tasks.map(task => {
                                                        return (
                                                            <Grid item xs={12}>
                                                                <Button className={classes.button} variant='outlined' onClick={() => this.openTask(task.id)}>
                                                                    <Typography variant='body2'>
                                                                        {task.id}
                                                                    </Typography>
                                                                </Button>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    )
                                })

                            :
                            <div>
                                <br/>
                                    <Typography variant='title'>
                                        You have no outstanding tests
                                    </Typography>
                                <br/>
                            </div>
                            }
                        </Grid>
                    </Paper>
                    <br/>
                    <Paper className={classes.root} elevation={1}>
                        <Typography variant='headline'>
                            Your currently outstanding Homework
                        </Typography>
                        <Divider/>
                        <br/>
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            {this.state.tasks.length > 0 ? 
                                this.state.tasks.map(subject => {
                                    return (
                                        <Grid item xs={8} l={4}>
                                            <Paper className={classes.container2} elevation={1}>
                                                <Typography variant='title'>
                                                    {subject.subject}
                                                </Typography>
                                                <Divider/>
                                                <Grid container
                                                    spacing={24}
                                                    direction='row'
                                                    justify='space-evenly'
                                                    alignContent='center'
                                                >
                                                    <br/>
                                                    {subject.tasks.map(task => {
                                                        return (
                                                            <Grid item xs={12}>
                                                                <Button className={classes.button} variant='outlined' onClick={() => this.openTask(task.id)}>
                                                                    <Typography variant='body2'>
                                                                        {task.id}
                                                                    </Typography>
                                                                </Button>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    )
                                })

                            :
                            <div>
                                <br/>
                                    <Typography variant='title'>
                                        You have no outstanding homework
                                    </Typography>
                                <br/>
                            </div>
                            }
                        </Grid>
                    </Paper>
                    <br/>
                    <Paper className={classes.root} elevation={1}>
                        <Typography variant='headline'>
                            Your Test History
                        </Typography>
                        <Divider/>
                        <br/>
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            {this.state.prevTests.length > 0 ? 
                                this.state.prevTests.map(subject => {
                                    return (
                                        <Grid item xs={8} l={4}>
                                            <Paper className={classes.container2} elevation={1}>
                                                <Typography variant='title'>
                                                    {subject.subject}
                                                </Typography>
                                                <Divider/>
                                                <Grid container
                                                    spacing={24}
                                                    direction='row'
                                                    justify='space-evenly'
                                                    alignContent='center'
                                                >
                                                    <br/>
                                                    {subject.tasks.map(task => {
                                                        return (
                                                            <Grid item xs={12}>
                                                                <Button className={classes.button} variant='outlined' onClick={() => this.handleClickOpen(task)}>
                                                                    <Typography variant='body2'>
                                                                        {task.id}
                                                                    </Typography>
                                                                </Button>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    )
                                })

                            :
                            <div>
                                <br/>
                                    <Typography variant='title'>
                                        You have no test history
                                    </Typography>
                                <br/>
                            </div>
                            }
                        </Grid>
                    </Paper>
                    <br/>
                    <Paper className={classes.root} elevation={1}>
                        <Typography variant='headline'>
                            Your Homework History
                        </Typography>
                        <Divider/>
                        <br/>
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            {this.state.prevTasks.length > 0 ? 
                                this.state.prevTasks.map(subject => {
                                    return (
                                        <Grid item xs={8} l={4}>
                                            <Paper className={classes.container2} elevation={1}>
                                                <Typography variant='title'>
                                                    {subject.subject}
                                                </Typography>
                                                <Divider/>
                                                <Grid container
                                                    spacing={24}
                                                    direction='row'
                                                    justify='space-evenly'
                                                    alignContent='center'
                                                >
                                                    <br/>
                                                    {subject.tasks.map(task => {
                                                        return (
                                                            <Grid item xs={6}>
                                                                <Button className={classes.button} variant='outlined' onClick={() => this.handleClickOpen(task)}>
                                                                    <Typography variant='body2'>
                                                                        {task.id}
                                                                    </Typography>
                                                                </Button>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    )
                                })

                            :
                            <div>
                                <br/>
                                    <Typography variant='title'>
                                        You have no homework history
                                    </Typography>
                                <br/>
                            </div>
                            }
                        </Grid>
                    </Paper>
                    <br/>
                    </div>
                    : 
                    
                    <Paper className={classes.root} elevation={1}>
                        <Typography variant='headline'>
                           You dont have any outstanding tasks or task history
                        </Typography>
                        <Divider/>
                    </Paper>
                )}
                
        </div>
        <Dialog
            open={this.state.open === true}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose()}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">
                <Typography variant='headline'>
                    {"Test feedback for: " + this.state.testTitle}
                </Typography>
            </DialogTitle>
        
            {this.state.score ? (
                <DialogContent>
                    
                    <DialogContentText id="alert-dialog-slide-description" className={classes.container}/>
                    <Divider/>
                    <span style={{width: '100%'}} >
                        <br/>
                        <Typography variant='title' >
                            {'Score: ' + this.state.score + '%'}
                        </Typography>
                    </span>
                    <br/>
                    <Divider/>
                    <Typography variant='subheading'>
                        {'You need to revise these questions:'}
                        <Divider/>
                    </Typography>
                    <br/>
                    <div>
                        {this.state.wrongQuestions.map(question => { 
                            return (
                                <div>
                                    <Typography variant='subheading'>
                                        {question.id + ': ' + question.question + ' ' }
                                        {'- ' + question.weight + ' marks'}
                                    </Typography>
                                    {question.file ?
                                        <Typography variant='body2'>
                                            {'File: ' + question.file}
                                        </Typography>
                                    :
                                        <div/>
                                    }
                                    <Typography variant='caption'>
                                        {'Areas: ' + question.tags.map(tag => { 
                                            return tag + ' '
                                        })}
                                    </Typography>
                                    
                                </div>
                            )
                        })}
                    </div>
                </DialogContent>
                
            ) : (<div className={classes.root}>
                    <Typography variant='body1'>
                        <CircularProgress className={classes.progress} size={50} />
                    </Typography>
                </div>
            )}
            
                <DialogActions>
                    <Button onClick={() => this.handleClose()} color="primary">
                        Close
                    </Button>
                </DialogActions>
                
        
            </Dialog>
        </div>
        )
    }
}
export default withStyles(styles)(ViewWrk);


// WEBPACK FOOTER //
// ./src/pages/View/viewHwk.jsx